import getAllPrivacy from "./getAllPrivacy";
import updateUserPrivacy from "./updateUserPrivacy";
import updateUserPrivacyProgram from "./updateUserPrivacyProgram";

export default {
  getAllPrivacy,
  updateUserPrivacy,
  updateUserPrivacyProgram,
};
